import * as yup from 'yup'

export const validationSchema = yup.object().shape({
  destinationId: yup.number().required('Destination is a required field'),
  depotId: yup.mixed().required('Yard is a required field'),
  ticketDate: yup.date().required('Ticket date is a required field'),
  ticketTime: yup.date().required('Ticket time is a required field'),
  ticketAmount: yup.number().required('Ticket amount is a required field'),
  materialId: yup.string().required('Material is a required field'),
  camion: yup.string().required('camion is a required field'),
  materialDescription: yup.string().nullable().optional(),
})

export interface FormValidation {
  destinationId: number
  depotId: number
  ticketDate: Date
  ticketTime: Date
  ticketAmount: number
  materialId: string
  camion: string
  materialDescription: string
}
